import { statusMeta } from "@/lib/mockData";
import { cn } from "@/lib/utils";

/**
 * Status pill: colored dot + label. Pulse animation for non-idle states.
 */
export default function StatusDot({ status, variant = "light", className }) {
  const meta = statusMeta[status] ?? statusMeta.idle;
  const isPulse = status === "debating" || status === "thinking";

  const pillClass =
    variant === "dark"
      ? "bg-white/10 text-white/85"
      : "bg-zinc-900/[0.04] text-zinc-700";

  return (
    <span
      data-testid={`status-${status}`}
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[10px] font-bold uppercase",
        pillClass,
        className,
      )}
      style={{ letterSpacing: "0.14em" }}
    >
      <span
        className={cn(
          "inline-block h-1.5 w-1.5 rounded-full",
          isPulse && "idea-dot-pulse",
        )}
        style={{ backgroundColor: meta.dot }}
      />
      {meta.label}
    </span>
  );
}
